import React, { useState } from "react";
import HeaderBar from "../HeaderBar/HeaderBar";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import styles from "./CallDivert.module.css";
import NewModal from "../NewModal/NewModal";

const CallDivert = () => {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [rules, setRules] = useState([]);
    const [isRuleDetailModalOpen, setIsRuleDetailModalOpen] = useState(false);
    const [selectedRule, setSelectedRule] = useState(null);

    // Form states
    const [type, setType] = useState("cold");
    const [reason, setReason] = useState("billing");
    const [customCondition, setCustomCondition] = useState("");
    const [businessHoursOnly, setBusinessHoursOnly] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isAnytime, setIsAnytime] = useState(true);
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
    const [sameEveryday, setSameEveryday] = useState(false);

    const [schedule, setSchedule] = useState({
        Monday: { enabled: true, from: "08:00 AM", to: "06:00 PM" },
        Tuesday: { enabled: true, from: "09:00 AM", to: "06:00 PM" },
        Wednesday: { enabled: true, from: "09:00 AM", to: "06:00 PM" },
        Thursday: { enabled: true, from: "09:00 AM", to: "06:00 PM" },
        Friday: { enabled: true, from: "09:00 AM", to: "11:00 PM" },
        Saturday: { enabled: false, from: "09:00 AM", to: "06:00 PM" },
        Sunday: { enabled: false, from: "09:00 AM", to: "06:00 PM" },
    });

    // Delete modal
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [ruleToDeleteIndex, setRuleToDeleteIndex] = useState(null);

    // NEW: Edit mode
    const [editingRuleIndex, setEditingRuleIndex] = useState(-1); // -1 = new rule

    const resetForm = () => {
        setReason("billing");
        setCustomCondition("");
        setType("cold");
        setBusinessHoursOnly(true);
        setPhoneNumber("");
        setIsAnytime(true);
        setEditingRuleIndex(-1);
    };

    const openFormForCreate = () => {
        resetForm();
        setIsFormVisible(true);
    };

    const handleCreateOrSave = () => {
        if (!isFormVisible) {
            openFormForCreate();
            return;
        }

        // Validation
        if (!phoneNumber.trim()) {
            alert("Please enter phone number");
            return;
        }

        const newRuleData = {
            id: Date.now(),
            reason,
            customCondition: reason === "custom" ? customCondition.trim() : "",
            type,
            phoneNumber: phoneNumber.trim(),

            // 🔥 MAIN FIX
            businessHoursOnly: !isAnytime, // toggle ON → false
        };

        if (editingRuleIndex >= 0) {
            // Update existing rule
            setRules((prev) =>
                prev.map((r, i) => (i === editingRuleIndex ? { ...r, ...newRuleData } : r))
            );
        } else {
            // Create new
            setRules((prev) => [...prev, newRuleData]);
        }

        setIsFormVisible(false);
        resetForm();
    };

    const handleDeleteClick = (index) => {
        setRuleToDeleteIndex(index);
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = () => {
        if (ruleToDeleteIndex !== null) {
            setRules((prev) => prev.filter((_, i) => i !== ruleToDeleteIndex));
        }
        setIsDeleteModalOpen(false);
        setRuleToDeleteIndex(null);
    };

    const cancelDelete = () => {
        setIsDeleteModalOpen(false);
        setRuleToDeleteIndex(null);
    };

    const toggleDay = (day) => {
        setSchedule((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                enabled: !prev[day].enabled,
            },
        }));
    };



    // NEW: open detail modal
    const openRuleDetailModal = (rule) => {
        setSelectedRule(rule);
        setIsRuleDetailModalOpen(true);
    };

    // Optional: close helper
    const closeRuleDetailModal = () => {
        setIsRuleDetailModalOpen(false);
        setSelectedRule(null);
    };
    return (
        <>

            <div className={styles.ConatinerBox}>
                <HeaderBar title="Dynamic Call Transfer" />

                {/* Empty state - no rules & no form */}
                {!isFormVisible && rules.length === 0 && (
                    <>
                        <div className={styles.mainDivContent}>
                            <div className={styles.CallDivertImg}>
                                <img src="/svg/call-divert.svg" alt="call-divert" />
                            </div>
                            <div className={styles.contentDiv}>
                                <h4>Call Transfer</h4>
                                <p>
                                    Create simple rules to automatically forward calls based on
                                    easily-defined conditions.
                                </p>
                            </div>
                        </div>

                        <div className={styles.BtnDiv}>
                            <AnimatedButton label="Create Rule" onClick={handleCreateOrSave} />
                        </div>
                    </>
                )}

                {/* Form - visible when creating/editing */}
                {isFormVisible && (
                    <div className={styles.formContainer}>
                        {/* WHEN */}
                        <div className={styles.section}>
                            <div className={styles.leblediv}>
                                <label className={styles.label}>WHEN</label>
                                <div className={styles.separatorLine} />
                            </div>

                            <div className={styles.field}>
                                <label className={styles.lableTitle}>
                                    Reason for Transfer
                                    <span className={styles.required}>Required</span>
                                </label>

                                <select
                                    className={styles.select}
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                >
                                    <option value="billing">Billing Queries</option>
                                    <option value="custom">Custom</option>
                                </select>

                                <p className={styles.hint}>
                                    If you choose <b className={styles.boldText}>Custom</b>, you'll be able to type your own
                                    forwarding conditions.
                                </p>
                            </div>

                            {reason === "custom" && (
                                <div className={styles.field}>
                                    <label className={styles.lableTitle}>
                                        Add Transfer Condition
                                        <span className={styles.required}>Required</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={styles.input}
                                        placeholder="e.g - If user shows frustration and anger"
                                        value={customCondition}
                                        onChange={(e) => setCustomCondition(e.target.value)}
                                    />
                                </div>
                            )}
                        </div>

                        {/* THEN */}
                        <div className={styles.section}>
                            <div className={styles.leblediv}>
                                <label className={styles.label}>THEN</label>
                                <div className={styles.separatorLine} />
                            </div>

                            <div className={styles.field}>
                                <label className={styles.lableTitle}>
                                    Forward Call To
                                    <span className={styles.required}>Required</span>
                                </label>

                                <div className={styles.phoneInput}>
                                    <span className={styles.countryCode}>🇮🇳 +91</span>
                                    <input
                                        type="tel"
                                        placeholder="985 XXX 88XX"
                                        className={styles.input}
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div
                                className={`${styles.card} ${!isAnytime ? styles.cardExpanded : ""
                                    }`}
                            >
                                <div className={styles.field}>
                                    <label className={styles.label}>Type</label>

                                    <div className={styles.transferType}>
                                        <span
                                            className={`${styles.slider} ${type === "warm" ? styles.right : ""
                                                }`}
                                        />

                                        <button
                                            className={`${styles.typeBtn} ${type === "cold" ? styles.active : ""}`}
                                            onClick={() => setType("cold")}
                                        >
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.66306 7.2057C6.98057 6.91747 7.18211 6.5144 7.18211 6.08206C7.21138 5.64971 7.03799 5.24665 6.74976 4.92913L4.44391 2.47916C4.15567 2.16165 3.72333 1.9894 3.29098 1.9894C2.85863 1.9894 2.42629 2.16279 2.13805 2.50845L1.1574 3.54542C0.00447738 4.78504 -0.313038 6.57185 0.321993 8.12772C1.87798 11.8747 5.62488 18.4173 13.0615 20.1187C13.3791 20.2054 13.6954 20.2336 14.0129 20.2336C15.1366 20.2336 16.2321 19.8012 17.0688 18.9658L17.9909 18.0437C18.3084 17.7262 18.4525 17.3231 18.4525 16.8908C18.4525 16.4584 18.2791 16.0554 17.9627 15.7671L15.4554 13.432C15.1378 13.1438 14.7348 12.9704 14.3024 12.9997C13.8701 13.0289 13.467 13.2012 13.1788 13.5187L12.3141 14.4982C12.0551 14.7865 11.6228 14.8732 11.2479 14.729C9.54777 13.951 6.54941 12.1642 5.5406 8.90705C5.42575 8.58953 5.5406 8.21575 5.79956 7.98494L6.66306 7.2057Z" fill="#B5A0F3" />
                                                <path d="M18.1624 9.07929H19.8918C19.8918 4.06464 15.8272 0 10.8125 0V1.72939C14.8771 1.72939 18.1624 5.01581 18.1624 9.07929Z" fill="#5F33E1" />
                                                <path d="M10.8125 5.99545C12.5126 5.99545 13.8963 7.37919 13.8963 9.07924H15.6257C15.6257 6.42774 13.4639 4.26606 10.8125 4.26606V5.99545Z" fill="#5F33E1" />
                                            </svg> Cold Transfer
                                        </button>

                                        <button
                                            className={`${styles.typeBtn} ${type === "warm" ? styles.active : ""}`}
                                            onClick={() => setType("warm")}
                                        >
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.66306 7.2057C6.98057 6.91747 7.18211 6.5144 7.18211 6.08206C7.21138 5.64971 7.03799 5.24665 6.74976 4.92913L4.44391 2.47916C4.15567 2.16165 3.72333 1.9894 3.29098 1.9894C2.85863 1.9894 2.42629 2.16279 2.13805 2.50845L1.1574 3.54542C0.00447738 4.78504 -0.313038 6.57185 0.321993 8.12772C1.87798 11.8747 5.62488 18.4173 13.0615 20.1187C13.3791 20.2054 13.6954 20.2336 14.0129 20.2336C15.1366 20.2336 16.2321 19.8012 17.0688 18.9658L17.9909 18.0437C18.3084 17.7262 18.4525 17.3231 18.4525 16.8908C18.4525 16.4584 18.2791 16.0554 17.9627 15.7671L15.4554 13.432C15.1378 13.1438 14.7348 12.9704 14.3024 12.9997C13.8701 13.0289 13.467 13.2012 13.1788 13.5187L12.3141 14.4982C12.0551 14.7865 11.6228 14.8732 11.2479 14.729C9.54777 13.951 6.54941 12.1642 5.5406 8.90705C5.42575 8.58953 5.5406 8.21575 5.79956 7.98494L6.66306 7.2057Z" fill="#B5A0F3" />
                                                <path d="M18.1624 9.07929H19.8918C19.8918 4.06464 15.8272 0 10.8125 0V1.72939C14.8771 1.72939 18.1624 5.01581 18.1624 9.07929Z" fill="#5F33E1" />
                                                <path d="M10.8125 5.99545C12.5126 5.99545 13.8963 7.37919 13.8963 9.07924H15.6257C15.6257 6.42774 13.4639 4.26606 10.8125 4.26606V5.99545Z" fill="#5F33E1" />
                                            </svg>  Warm Transfer
                                        </button>
                                    </div>
                                    <p className={styles.hint5}>
                                        {type === "cold"
                                            ? "AI transfers the call to the next agent without a debrief."
                                            : "AI provides a debrief to the next agent after transferring the call."}
                                    </p>
                                </div>
                                <div className={styles.divider}></div>
                                <div className={styles.field2}>
                                    <label className={styles.toggleLabel}>
                                        Forward Any time(24x7)
                                        <input
                                            type="checkbox"
                                            checked={isAnytime}
                                            onChange={(e) => setIsAnytime(e.target.checked)}
                                        />
                                        <span className={styles.toggle} />
                                    </label>
                                    <p className={styles.hint6}>Define call forwarding schedule for above number.</p>
                                    {!isAnytime && (
                                        <div className={styles.schedules}>
                                            <div className={styles.schedulesImg} onClick={() => setIsScheduleModalOpen(true)}>
                                                <img src="/svg/schedule_icon.svg" alt="schedule_icon" />
                                                <p className={styles.schedulesText}>5 schedules from <b>8am to 11pm</b></p>
                                            </div>
                                            <div className={styles.editIcon} onClick={() => setIsScheduleModalOpen(true)}>
                                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="29" height="29" rx="9.5" fill="white" stroke="#E8E9EE"></rect><path d="M14.1167 21.1213H21.0141" stroke="#24252C" stroke-linecap="round"></path><path d="M17.5655 8.47616C17.8704 8.17128 18.2839 8 18.7151 8C19.1462 8 19.5597 8.17128 19.8646 8.47616C20.1695 8.78105 20.3408 9.19455 20.3408 9.62572C20.3408 10.0569 20.1695 10.4704 19.8646 10.7753L11.0513 19.5886L7.98584 20.3549L8.75221 17.2895L17.5655 8.47616Z" stroke="#24252C" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </svg>
                                            </div>

                                        </div>
                                    )}
                                </div>
                                 <div className={styles.divider3}></div>
                                  <div className={styles.field2}>
                                    <label className={styles.toggleLabel}>
                                        Avoid Voicemail
                                        <input
                                            type="checkbox"

                                        />
                                        <span className={styles.toggle} />
                                    </label>
                                    <p className={styles.hint6}>Allows AI to monitor if Call picked by Human or went to Voicemail.</p>
                                </div>
                            </div>
                            <p className={styles.hint4}>If call not picked in 20 seconds, AI Receptionist will continue the Call.</p>
                        </div>

                        <div className={styles.BtnDiv}>
                            <AnimatedButton label="Save Rule" onClick={handleCreateOrSave} />
                        </div>
                    </div>
                )}

                {/* Rules List */}
                {rules.length > 0 && !isFormVisible && (
                    <div className={styles.ruleCardMain}>
                        <div className={styles.SearchBar}>
                            <div className={styles.searchContainer}>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className={styles.searchInput}
                                />

                                <button className={styles.searchButton} type="submit">
                                    <svg
                                        style={{ width: "24px", height: "24px" }}
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="#666666"
                                            d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        {rules.map((rule, index) => (
                            <div className={styles.ruleCard} key={rule.id}>
                                <div className={styles.ruleSection2} onClick={() => openRuleDetailModal(rule)}>
                                    <div className={styles.ruleThenRow}>
                                        <div className={styles.numbertoglediv}>
                                            <div>
                                                <p className={styles.hint5}>Forward to</p>
                                                <p className={styles.phone}>{rule.phoneNumber}</p>
                                            </div>
                                            <div>
                                                <label className={styles.toggleLabel}>
                                                    <input type="checkbox" readOnly checked={rule.businessHoursOnly} />
                                                    <span className={styles.toggle} />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.riboonmain}>
                                        <div>
                                            <span className={styles.role}>
                                                {rule.reason === "billing"
                                                    ? "Billing Queries"
                                                    : `Custom : ${rule.customCondition
                                                        ? rule.customCondition.slice(0, 3) + ".."
                                                        : ""
                                                    }`}
                                            </span>
                                        </div>
                                        <div>
                                            <span className={styles.transferBadge}>
                                                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.66306 7.2057C6.98057 6.91747 7.18211 6.5144 7.18211 6.08206C7.21138 5.64971 7.03799 5.24665 6.74976 4.92913L4.44391 2.47916C4.15567 2.16165 3.72333 1.9894 3.29098 1.9894C2.85863 1.9894 2.42629 2.16279 2.13805 2.50845L1.1574 3.54542C0.00447738 4.78504 -0.313038 6.57185 0.321993 8.12772C1.87798 11.8747 5.62488 18.4173 13.0615 20.1187C13.3791 20.2054 13.6954 20.2336 14.0129 20.2336C15.1366 20.2336 16.2321 19.8012 17.0688 18.9658L17.9909 18.0437C18.3084 17.7262 18.4525 17.3231 18.4525 16.8908C18.4525 16.4584 18.2791 16.0554 17.9627 15.7671L15.4554 13.432C15.1378 13.1438 14.7348 12.9704 14.3024 12.9997C13.8701 13.0289 13.467 13.2012 13.1788 13.5187L12.3141 14.4982C12.0551 14.7865 11.6228 14.8732 11.2479 14.729C9.54777 13.951 6.54941 12.1642 5.5406 8.90705C5.42575 8.58953 5.5406 8.21575 5.79956 7.98494L6.66306 7.2057Z" fill="#B5A0F3" />
                                                    <path d="M18.1624 9.07929H19.8918C19.8918 4.06464 15.8272 0 10.8125 0V1.72939C14.8771 1.72939 18.1624 5.01581 18.1624 9.07929Z" fill="#5F33E1" />
                                                    <path d="M10.8125 5.99545C12.5126 5.99545 13.8963 7.37919 13.8963 9.07924H15.6257C15.6257 6.42774 13.4639 4.26606 10.8125 4.26606V5.99545Z" fill="#5F33E1" />
                                                </svg>
                                                <p>{rule.type === "cold" ? "Cold Transfer" : "Warm Transfer"}</p>
                                            </span>
                                        </div>

                                    </div>
                                    {/* Forward Any time (24x7) */}
                                    {!rule.businessHoursOnly && (
                                        <div className={styles.schedules}>
                                            <div className={styles.schedulesImg}>
                                                <img src="/svg/schedule_icon.svg" alt="schedule_icon" />
                                                <p className={styles.schedulesText}>
                                                    Forward Any time (24x7)
                                                </p>
                                            </div>
                                        </div>
                                    )}


                                    {/* Schedule text — when toggle is OFF */}
                                    {rule.businessHoursOnly && (
                                        <div className={styles.schedules}>
                                            <div className={styles.schedulesImg}>
                                                <img src="/svg/schedule_icon.svg" alt="schedule_icon" />
                                                <p className={styles.schedulesText}>
                                                    5 schedules from <b>8am to 11pm</b>
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    <div className={styles.ruleNumber}>
                                        {index + 1}
                                    </div>
                                </div>
                            </div>
                        ))}


                        <div className={styles.addButton} onClick={handleCreateOrSave}>
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="44" height="44" rx="22" fill="#5F33E1" />
                                <path d="M21.9998 11.9167C22.6959 11.9167 23.2603 12.481 23.2603 13.1771V20.7396H30.8228C31.5189 20.7396 32.0832 21.3039 32.0832 22C32.0832 22.6961 31.5189 23.2604 30.8228 23.2604H23.2603V30.8229C23.2603 31.519 22.6959 32.0833 21.9998 32.0833C21.3037 32.0833 20.7394 31.519 20.7394 30.8229V23.2604H13.1769C12.4808 23.2604 11.9165 22.6961 11.9165 22C11.9165 21.3039 12.4808 20.7396 13.1769 20.7396H20.7394V13.1771C20.7394 12.481 21.3037 11.9167 21.9998 11.9167Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                )}
            </div>
            {isDeleteModalOpen && (
                <NewModal
                    isOpen={isDeleteModalOpen}
                    onClose={cancelDelete}
                    title="Delete Rule"
                    height="auto"
                >
                    <div className={styles.modalContent}>
                        <h3>Are you sure?</h3>
                        <p>
                            Do you really want to delete this routing rule?<br />
                            This action cannot be undone.
                        </p>

                        <div className={styles.modalButtons}>
                            <button className={styles.cancelBtn} onClick={cancelDelete}>
                                Cancel
                            </button>
                            <button className={styles.deleteBtn} onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>

                </NewModal>)}

            {/* MODAL */}
            {isScheduleModalOpen && (
                <NewModal
                    isOpen={isScheduleModalOpen}
                    onClose={() => setIsScheduleModalOpen(false)}
                    title="Call Forwarding Schedule"
                    height="auto"
                    bodyPadding="20px 20px 100px 20px"

                >
                    {/* Header */}
                    <div className={styles.scheduleModalHeader}>
                        <h4>Same Schedule Everyday</h4>

                        <label className={styles.scheduleModalToggle}>
                            <input
                                type="checkbox"
                                checked={sameEveryday}
                                onChange={() => setSameEveryday(!sameEveryday)}
                            />
                            <span />
                        </label>
                    </div>

                    <p className={styles.scheduleModalSubText}>
                        Apply same daily schedule to all the days selected
                    </p>

                    {/* Schedule Rows */}
                    <div className={styles.dayMainDiv}>
                        {Object.keys(schedule).map((day) => (

                            <div key={day} className={styles.scheduleModalRow}>
                                <label className={styles.scheduleModalDay}>
                                    <input
                                        type="checkbox"
                                        checked={schedule[day].enabled}
                                        onChange={() => toggleDay(day)}
                                    />
                                    <span>{day}</span>
                                </label>

                                <div className={styles.scheduleModalTime}>
                                    <span className={styles.dayfrom}>{schedule[day].from}</span>
                                    <span>-</span>
                                    <span className={styles.dayto}>{schedule[day].to}</span>
                                </div>
                            </div>

                        ))}
                    </div>

                    <div className={styles.scheduleButton}>
                        <AnimatedButton label="Save" />
                    </div>
                </NewModal>
            )}
            {/* ────────────────── NEW DETAIL/VIEW MODAL ────────────────── */}
            {isRuleDetailModalOpen && selectedRule && (
                <NewModal
                    isOpen={isRuleDetailModalOpen}
                    onClose={closeRuleDetailModal}
                    title="Billing Department Detail"
                    height="auto"
                    bodyPadding="0"
                >
                    <div className={styles.ruleDetailModalContainer}>
                        {/* Header strip */}
                        <div className={styles.ruleHeader}>
                            <div className={styles.ruleTitle}>
                                <span className={styles.ruleIcon}><img src="/svg/rule-icon.svg" alt="rule-icon" /></span>
                                Routing Rule: {String(rules.findIndex(r => r.id === selectedRule.id) + 1).padStart(2, '0')}
                            </div>
                            <div className={styles.ruleActions}>
                                <button className={styles.editIconBtn} onClick={() => {
                                    // same edit logic as before
                                    setReason(selectedRule.reason);
                                    setCustomCondition(selectedRule.customCondition || "");
                                    setType(selectedRule.type);
                                    setPhoneNumber(selectedRule.phoneNumber);
                                    setIsAnytime(!selectedRule.businessHoursOnly);
                                    setEditingRuleIndex(rules.findIndex(r => r.id === selectedRule.id));
                                    setIsFormVisible(true);
                                    closeRuleDetailModal();
                                }}>
                                    <img src="/svg/edit-icon3.svg" alt="edit-icon3" />
                                </button>
                                <button className={styles.deleteIconBtn} onClick={() => {

                                }}>
                                    <img src="/svg/delete-icon3.svg" alt="delete-icon3" />
                                </button>
                            </div>
                        </div>

                        <div className={styles.ruleSubtitle}>
                            <p className={styles.topwhenThen}><span>WHEN</span> matches, <span>THEN</span> forward instantly</p>
                        </div>
                        <div className={styles.sectioncardDiv}>
                            {/* WHEN section */}
                            <div className={styles.sectionCard}>
                                <div className={styles.sectionTitle}>
                                    <h4>WHEN</h4>
                                    <p className={styles.verticalLine}></p>
                                </div>

                                <div className={styles.detailList}>
                                    <div className={styles.reasonDiv}>
                                        <span className={styles.bullet}><img src="/svg/dot_icon.svg" alt="dot_icon" /></span>
                                        <div>
                                            <div className={styles.customDiv}>
                                                <strong className={styles.strongText}>Reason:</strong>
                                                <p className={styles.pText}>{selectedRule.reason === "billing" ? "Billing Queries" : "Custom"}</p>
                                            </div>

                                            <p>{selectedRule.reason === "custom" && selectedRule.customCondition && (
                                                <div className={styles.subDetail}>
                                                    {selectedRule.customCondition}
                                                </div>
                                            )}</p>
                                        </div>


                                    </div>

                                    <div className={styles.reasonDiv}>
                                        <span className={styles.bullet}><img src="/svg/dot_icon.svg" alt="dot_icon" /></span>
                                        <div>
                                            <div className={styles.duringDiv}>
                                                <strong className={styles.strongText}>During:</strong>
                                                <p className={styles.pText}> {selectedRule.businessHoursOnly
                                                    ? "Business hours only"
                                                    : "Anytime (24×7)"}</p>
                                            </div>
                                            <div><p>
                                                {!selectedRule.businessHoursOnly && (
                                                    <div className={styles.subDetail}>5 Schedules from 8am to 11pm</div>
                                                )}
                                            </p></div>
                                        </div>
                                    </div>


                                    <div className={styles.AvoidDIv}>
                                        <span className={styles.bullet}><img src="/svg/dot_icon.svg" alt="dot_icon" /></span>
                                        <div className={styles.voicemaildiv}>
                                            <strong className={styles.strongText}>Avoid Voicemail:</strong>
                                            <p className={styles.pText}>NO</p>
                                        </div>

                                    </div>


                                    <div className={styles.EmergencyDIv}>
                                        <span className={styles.bullet}><img src="/svg/dot_icon.svg" alt="dot_icon" /></span>
                                        <div className={styles.situationDiv}>
                                            <strong className={styles.strongText}>Emergency situation Bypass:</strong>
                                            <p className={styles.pText}>No</p>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {/* THEN section */}
                            <div className={styles.sectionCard}>
                                <div className={styles.sectionTitle}>
                                    <h4>THEN</h4>
                                    <p className={styles.verticalLine}></p>
                                </div>

                                <div className={styles.thenContent}>
                                    <div className={styles.forwardRow}>
                                        <div className={styles.forwardLabel}>
                                            <span className={styles.countryTag}>US</span>
                                            <div>
                                                <p className={styles.hint6} >Forward to</p>
                                                <div className={styles.phoneNumber}>
                                                    <p> +91{selectedRule.phoneNumber}</p>
                                                </div>

                                            </div>
                                        </div>
                                        <div></div>
                                        <label className={styles.toggleLabel}>
                                            <input
                                                type="checkbox"
                                                checked={isAnytime}
                                                onChange={(e) => setIsAnytime(e.target.checked)}
                                            />
                                            <span className={styles.toggle} />
                                        </label>
                                    </div>


                                    <div>
                                        <span className={styles.transferBadge}>
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.66306 7.2057C6.98057 6.91747 7.18211 6.5144 7.18211 6.08206C7.21138 5.64971 7.03799 5.24665 6.74976 4.92913L4.44391 2.47916C4.15567 2.16165 3.72333 1.9894 3.29098 1.9894C2.85863 1.9894 2.42629 2.16279 2.13805 2.50845L1.1574 3.54542C0.00447738 4.78504 -0.313038 6.57185 0.321993 8.12772C1.87798 11.8747 5.62488 18.4173 13.0615 20.1187C13.3791 20.2054 13.6954 20.2336 14.0129 20.2336C15.1366 20.2336 16.2321 19.8012 17.0688 18.9658L17.9909 18.0437C18.3084 17.7262 18.4525 17.3231 18.4525 16.8908C18.4525 16.4584 18.2791 16.0554 17.9627 15.7671L15.4554 13.432C15.1378 13.1438 14.7348 12.9704 14.3024 12.9997C13.8701 13.0289 13.467 13.2012 13.1788 13.5187L12.3141 14.4982C12.0551 14.7865 11.6228 14.8732 11.2479 14.729C9.54777 13.951 6.54941 12.1642 5.5406 8.90705C5.42575 8.58953 5.5406 8.21575 5.79956 7.98494L6.66306 7.2057Z" fill="#B5A0F3" />
                                                <path d="M18.1624 9.07929H19.8918C19.8918 4.06464 15.8272 0 10.8125 0V1.72939C14.8771 1.72939 18.1624 5.01581 18.1624 9.07929Z" fill="#5F33E1" />
                                                <path d="M10.8125 5.99545C12.5126 5.99545 13.8963 7.37919 13.8963 9.07924H15.6257C15.6257 6.42774 13.4639 4.26606 10.8125 4.26606V5.99545Z" fill="#5F33E1" />
                                            </svg>
                                            <p> {selectedRule.type === "cold" ? "Cold Transfer" : "Warm Transfer"}</p>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </NewModal>
            )}
        </>
    );
};

export default CallDivert;
